import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export class SmsReminderPreview extends Component {
  render () {
    var reminders = this.props.reminders.filter(x => x.selected);
    var others = this.props.others.filter(x => x.selected);
    return (
      <div className="container">
        <p>
          In Gate Alert is set for
          <b> {this.props.minutes} minutes </b>
          before my estimated in gate times and will be sent to:
        </p>
        { reminders.map((reminder) =>
            <li key={reminder.user_id}><b>{reminder.name}: </b>{this.props.maskMobile(reminder.mobile)}</li>
          )
        }
        { others.map((other) =>
            <li key={other.other_id}>{this.props.maskMobile(other.mobile)}</li>
          )
        }
        <br/>
        <div className="row">
          <a className="btn btn-success" onClick={this.props.editAction}>Edit In Gate Alert</a>
          <br/><br/>
          <a className="btn btn-primary" href='/rts'>Back</a>
        </div>
      </div>
    );
  }
}
